import type { IconSvgObject } from './types';

const SubmergeIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "14", r: "4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 2V2.5M7 5V6M7 8.5V9.5M17 2V3M17 5.5V6M17 8.5V9.5M12 2V3M12 5.5V6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 12V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2 14.8968C4.26409 16.8667 6.1743 15.779 8.0217 14.857C9.59668 14.0709 11.126 13.4052 12.79 14.857C16.0467 17.6487 19 14 22 14", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }]
];

export default SubmergeIcon;
